













import { IQSelectOptions } from '@/quasar-types'
import { UwInput } from '@ultraware/vee-form-handler'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {
    UwInput,
  },
})
export default class SelectWithFilter extends Vue {
  @Prop({ type: Array, default: [] }) public options!: IQSelectOptions[]

  public filteredOptions: IQSelectOptions[] = this.options

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public filterFunction(val: string, update: any): void {
    if (val === '') {
      update(() => {
        this.filteredOptions = this.options
      })
      return
    }

    update(() => {
      const needle = val.toLowerCase()
      this.filteredOptions = this.options.filter((v: IQSelectOptions): boolean => {
        return v.label.toLowerCase().indexOf(needle) > -1
      })
    })
  }
}
